import React, { Fragment } from "react"
import logo from "../images/img_logo.svg"
import Link from "./Link"
import { useSetting } from "../data/useSetting"
import { FaLine, FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa"
import useContactInfo from "../data/useContactInfo"

export function Logo() {
  return (
    <Link to="/" className="flex-shrink-0">
      <img src={logo} alt="mental hug logo" width={176} height={36} />
    </Link>
  )
}

export default function Footer() {
  const { contentfulSetting: contact } = useSetting()
  const { contactData } = useContactInfo()
  const caseNumbers = contactData.map(({ name, caseNumber }, index) => (
    <Fragment key={`caseNumber-${index}`}>
      <p className="mt-4 font-bold">{name}</p>
      <p className="mt-1">立案號碼 {caseNumber}</p>
    </Fragment>
  ))
  const offices = contactData.map(
    ({ name, phoneNumber, email, address }, index) => (
      <div key={`office-${index}`} className="space-y-1">
        <p className="font-bold">{name}</p>
        <p>{phoneNumber}</p>
        <p>{email}</p>
        <p>{address}</p>
      </div>
    )
  )
  return (
    <footer className="bg-gray-50">
      <div className="wrapper py-12 lg:py-16">
        <div className="grid gap-8 border-gray-300 sm:max-w-max sm:mx-auto lg:max-w-full lg:gap-0 lg:grid-cols-3 lg:border-b lg:pb-16">
          {/* Basic Info */}
          <div className="text-center lg:text-left text-gray-700">
            <div className="flex justify-center lg:justify-start">
              <Logo />
            </div>
            {caseNumbers}
          </div>
          <div className="border-b border-gray-300 lg:hidden" />
          {/* Contact Info */}
          <div>
            <p className="hidden lg:block mb-5 text-2xl tracking-wider font-bold text-red-300">
              聯絡資訊
            </p>
            <div className="text-gray-700 text-center space-y-6 lg:text-left">
              {offices}
            </div>
          </div>
          <div className="border-b border-gray-300 lg:hidden" />
          {/* Social Media */}
          <div>
            <p className="hidden lg:block mb-5 text-2xl tracking-wider font-bold text-red-300">
              社群媒體
            </p>
            <div className="space-y-3 text-center lg:text-left">
              <div className="flex space-x-5 justify-center lg:justify-start">
                <Link as="a" to={contact.lineLink} className="text-gray-400">
                  <FaLine className="w-9 h-9" />
                </Link>
                <Link as="a" to={contact.fbLink} className="text-gray-400">
                  <FaFacebook className="w-9 h-9" />
                </Link>
                <Link as="a" to={contact.igLink} className="text-gray-400">
                  <FaInstagram className="w-9 h-9" />
                </Link>
                <Link as="a" to={contact.youtubeLink} className="text-gray-400">
                  <FaYoutube className="w-9 h-9" />
                </Link>
              </div>
              <p className="text-gray-700">
                全預約制，請透過LINE@或臉書粉專私訊
              </p>
            </div>
          </div>
        </div>
        {/* Copyright */}
        <p className="text-gray-500 text-center mt-8">
          Copyright © {new Date().getFullYear()} Mental Hug All rights reserved.
        </p>
        <p className="text-gray-500 text-center mt-2">
          Powered by
          <span className="ml-1">
            <Link as="a" to="https://welly.tw">
              Welly SEO
            </Link>
          </span>
        </p>
      </div>
    </footer>
  )
}
